export const PopularizeLink = [
  {
    path: "/platform-electronic-visa/popularizeLink",
    name: "popularizeLink",
    component: () => import("@/views/platform-electronic-visa/popularizeLink/index.vue"),
    meta: { title: "推广链接", icon: "dashboard" },
  },
];
